// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b;

const calcWinsize = () => {
    return {width: window.innerWidth, height: window.innerHeight};
};

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

// Gets the mouse position
const getMousePos = (e) => {
    let posx = 0;
    let posy = 0;
    if (!e) e = window.event;
    if (e.screenX || e.screenY) {
        posx = e.screenX;
        posy = e.screenY;
    } else if (e.clientX || e.clientY) {
        posx = e.clientX;
        posy = e.clientY;
    }
    return {x: posx, y: posy}
};

const getElementRotate = (el) => {

    var st = window.getComputedStyle(el, null);
    var tr = st.getPropertyValue("-webkit-transform") ||
        st.getPropertyValue("-moz-transform") ||
        st.getPropertyValue("-ms-transform") ||
        st.getPropertyValue("-o-transform") ||
        st.getPropertyValue("transform") ||
        'none';

    if (tr === 'none') {
        return null;
    }

    var values = tr.split('(')[1];
    values = values.split(')')[0];
    values = values.split(',');

    var a = values[0];
    var b = values[1];
    var c = values[2];
    var d = values[3];
    var scale = Math.sqrt(a*a + b*b);

    var sin = b/scale;

    return Math.round(Math.asin(sin) * (180 / Math.PI));
}

export {map, lerp, calcWinsize, getRandomNumber, getMousePos, getElementRotate};